export default __webpack_public_path__ + "assets/process-1.8a1ad42b.png";